import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 24px;

  div {
    h6 {
      color: ${({ theme }) => theme.ds.colors.primary600};
      font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
      font-size: ${({ theme }) => theme.ds.typography.size.medium};
      display: inline;
    }
    span {
      color: ${({ theme }) => theme.ds.colors.neutral700};
      font-weight: ${({ theme }) => theme.ds.typography.weight.normal};
      font-size: ${({ theme }) => theme.ds.typography.size.medium};
    }
  }
`

export const DataOverview = styled.div`
  display: grid;
  grid-template-columns: 0.7fr 1fr;
  gap: 2px 40px;
  align-items: start;
`
export const SurgicalContainer = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  gap: 2px 40px;
  align-items: start;
`

export const SurgeryData = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 2px 10px;
`

export const SurgicalDataRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 9px;
  margin-left: -100px;
  margin-right: 300px;
  width: 100%;
`

// TODO: Ajustar isso
export const SurgicalDataOptional = styled.div`
  div {
    display: flex;
    align-items: start;
    gap: 9px;
    margin-left: -490px;
    &:last-child {
      margin-top: 45px;
    }
  }
`

export const SurgicalDataAnesthesiology = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`

export const ProceduresWrapper = styled.div`
  width: 100%;
  margin-top: 12px;
`

export const ProvidersWrapper = styled.div`
  /* display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px 40px;
  margin-top: 12px;
  margin-bottom: 20px; */
`
export const DocumentsContainer = styled.div``

export const HeadingWrapper = styled(DataOverview)`
  grid-template-columns: 0.7fr 0fr;
  padding-right: 30px;
`
export const Edit = styled.p`
  align-self: center;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: ${({ theme }) => theme.font.semiBold};
  font-size: ${({ theme }) => theme.font.sizes.medium};
  text-decoration: underline ${({ theme }) => theme.colors.primary};
  cursor: pointer;
`

export const OpmeColumnsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 12px;
`

export const OpmeCategoryColumn = styled.div`
  display: flex;
  flex-direction: column;
`

export const OpmeCategoryHeading = styled.h5`
  ${({ theme }) => css`
    font-weight: ${theme.ds.typography.weight.bold};
    font-size: ${theme.ds.typography.size.medium};
    color: ${theme.ds.colors.textSecondary};
    margin-bottom: 0;
  `}
`

export const OpmeItemWrapper = styled.div<{ denied?: boolean }>`
  ${({ theme, denied }) => css`
    div {
      h6 {
        color: ${denied
          ? theme.ds.colors.danger500
          : theme.ds.colors.primary600};
        font-weight: ${theme.ds.typography.weight.bold};
        font-size: ${theme.ds.typography.size.medium};
        display: inline;
      }
      span {
        color: ${theme.ds.colors.neutral700};
        font-weight: ${theme.ds.typography.weight.normal};
        font-size: ${theme.ds.typography.size.medium};
      }
    }
  `}
`

export const DeniedReasonWrapper = styled.div`
  background-color: ${({ theme }) => theme.ds.colors.danger50};
  padding: 16px;
  margin-top: 16px;
`
